import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import { promise } from "when";
import axios from "axios";

var _default =
/*#__PURE__*/
function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "GetTaskStatus",
    value: function GetTaskStatus(task, propertyId) {
      var subTaskId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var overrideCheckAll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (subTaskId == null) return axios.get("/api/tasks/ByProperty/".concat(propertyId, "/").concat(task, "/").concat(overrideCheckAll), {
        doNotShowLoading: true
      });else return axios.get("/api/tasks/ByProperty/".concat(propertyId, "/").concat(task, "/").concat(subTaskId, "/").concat(overrideCheckAll), {
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetTaskStatuses",
    value: function GetTaskStatuses(task) {
      var subTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (subTaskId == null) return axios.get("/api/tasks/ByUser/".concat(task), {
        doNotShowLoading: true
      });else return axios.get("/api/tasks/ByUser/".concat(task, "/").concat(subTaskId), {
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetTaskStatusesByAlphaNumeric",
    value: function GetTaskStatusesByAlphaNumeric(task, letterGroup) {
      return axios.get("/api/tasks/ByUserAlphaNumeric/".concat(task, "/").concat(letterGroup), {
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetTaskStatusesNavigation",
    value: function GetTaskStatusesNavigation(task) {
      var subTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (subTaskId == null) return axios.get("/api/tasks/GetMultipleDashboard/".concat(task), {
        doNotShowLoading: true
      });else return axios.get("/api/tasks/GetMultipleDashboard/".concat(task, "/").concat(subTaskId), {
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetToDos",
    value: function GetToDos(userId) {
      var letterGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return axios.get("/api/tasks/GetToDo", {
        params: {
          userId: userId,
          letterGroup: letterGroup
        },
        doNotShowLoading: true
      });
    }
  }, {
    key: "getPropertiesCount",
    value: function getPropertiesCount(userId) {
      return axios.get("/api/tasks/GetPropertiesCount/", {
        params: {
          userId: userId
        },
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetToDoProperty",
    value: function GetToDoProperty(propertyId) {
      return axios.get("/api/tasks/GetToDoProperty/".concat(propertyId), {
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetToDoManagementCompanyId",
    value: function GetToDoManagementCompanyId(managementCompanyId) {
      return axios.get("/api/tasks/GetToDoManagementCompany/".concat(managementCompanyId), {
        doNotShowLoading: true
      });
    }
  }]);

  return _default;
}();

export { _default as default };